// Utility function to format error messages from API responses
export const formatErrorMessage = (error, defaultMessage = 'An error occurred') => {
  if (!error?.response?.data?.detail) {
    return defaultMessage;
  }

  const detail = error.response.data.detail;

  if (typeof detail === 'string') {
    return detail;
  }

  if (Array.isArray(detail)) {
    return detail.map(e => {
      if (typeof e === 'string') return e;
      if (typeof e === 'object' && e.msg) return e.msg;
      return 'Validation error';
    }).join(', ');
  }

  if (typeof detail === 'object' && detail.msg) {
    return detail.msg;
  }

  return defaultMessage;
};

// Format currency display
export const formatCurrency = (amount, currency = 'USD') => {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  } catch (error) {
    return `${currency} ${amount.toFixed(2)}`;
  }
};

// Validate email format
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Truncate text with ellipsis
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};